module.exports = __webpack_public_path__ + "media/3.1c95f124.mp3";